<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">11.</span>
          <span>Confirmation</span>
        </div>
        <p>
          Confirmation and attestation that all information at the point of
          application is true.
        </p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  I can confirm that I have completed questions truthfully as of
                  the date of the application.
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.Confirmation.AnswersConfirmed.IsCompleted'
                    )
                  "
                >
                  <el-radio-group
                    v-model="confirmation.answersConfirmed.isCompleted"
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  I can confirm all documents uploaded are valid as of the date
                  of the application.
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.Confirmation.ReviewConfirmed.IsUploadedDocumentsValid'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      confirmation.reviewConfirmed.isUploadedDocumentsValid
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Print Name
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.Confirmation.PrintedName'
                    )
                  "
                >
                  <el-input
                    type="text"
                    v-model="confirmation.printedName"
                    placeholder="Name"
                    disabled
                  />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Signature
                </label>
                <el-form-item>
                  <div class="reviewer-feedback-signature-header">
                    <span class="reviewer-feedback-signature-header-title">
                      <i class="fa fa-pencil-square-o"></i>Digital Signature
                    </span>
                    <span class="reviewer-feedback-signature-header-clear" style="margin-left: 80px;" @click="resetSignature">
                      <i class="fa fa-eraser"></i>Clear
                    </span>
                  </div>
                  <VueSignaturePad
                    width="250px"
                    height="100px"
                    ref="checklistSignature"
                    style="
                      border: 1px solid #e0e2e9;
                      border-radius: 5px;
                      margin-top: 10px;
                    "
                  />
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="confirmSignature"
                >
                  Complete
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <el-dialog style="z-index: 1000"
        :visible="showErrorWindow"
        :show-close="true"
        width="750px"
      >
        <div slot="title">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :xs="24" :sm="24" style="height: 80px; padding: 15px 0px 15px 0px;">
              <span style="font-size: 25px;">Please review details below</span>
            </el-col>
          </el-row>
        </div>
        <el-divider></el-divider>
        <button
          type="button"
          aria-label="Close"
          class="el-dialog__headerbtn"
          @click="closeErrorWindow(null)"
        >
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
        <el-form>
            <!-- <span>Please review details below</span> -->
          <div v-for="(item, index) in modelState" :key="index">
            <span style="color: red;">{{item[0]}}</span>
          </div>
        </el-form>

        <span
          class="dialog-footer ts-app-shell--header_actions flexed"
          style="margin-top: 30px"
        >
          <el-button class="btn-details ts-btn-secondary wide" @click="closeErrorWindow">
            OK
          </el-button>
        </span>
      </el-dialog>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import { dataURItoBlob } from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      showErrorWindow: false,
      existingChecklist: {},
      checklistSignature: "",
      completeInd: false,
      modelState: {},
      loading: false,
      confirmation: {
        answersConfirmed: {
          isCompleted: null
        },
        reviewConfirmed: {
          isUploadedDocumentsValid: null
        },
        printedName: null,
        digitallySignedFile: {
          fileId: null,
          fileName: null
        },
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.path.match("wioa/complete-checklist/") == null &&
      !this.completeInd
    ) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
        .then(() => {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        })
        .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0,0);
    this.confirmation.printedName = this.$store.state.account.current_user.fullName;
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          // this.confirmation = res.checklist.confirmation;
          if (res.checklist.confirmation)
            this.confirmation = res.checklist.confirmation;
            this.existingChecklist = res.checklist;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    closeErrorWindow(){
      this.showErrorWindow = false;
      this.modelState = {};
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistEight",
        params: { checklistId: this.getChecklistId() }
      });
    },
    saveSignature(callback){
      this.loading = true;
      const { isEmpty, data: signatureData } = this.$refs.checklistSignature.saveSignature();

      if(signatureData == null){
        this.showMessagePopup("Digital Signature", "Please provide your digital signature.", "error");
        this.loading = false;
        return false;
      }

      this.$store
        .dispatch("wioa/generateUploadDocumentMetadata", this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.$store
            .dispatch("common/uploadDocumentWithReturnUrl", {
              file: dataURItoBlob(signatureData),
              objectId: this.editChecklistId == null
                ? this.getChecklistId()
                : this.editChecklistId + "/Signature/" + metadata.documentId,
              bucketType: BucketType.WioaChecklist,
              fileExtension: "png"
            })
            .then(() => {
              // this.document.id = metadata.documentId;
              // this.document.filename = file.name;
              // this.document.isImage = utils.isImage(file.name);
              // this.document.documentObjectId = metadata.documentObjectId;
              // this.document.documentObjectUrl = url;
              this.confirmation.digitallySignedFile.fileId = (this.editChecklistId == null) ? this.getChecklistId() : this.editChecklistId + "/Signature/" + metadata.documentId;
              this.confirmation.digitallySignedFile.fileName = 'jobseekerSignature';
              callback();
            })
            .catch((res) => {
              this.isLoading = false;
              if(res.ObjectId[0] == 'The Object Id field is required.')
              {
                this.showMessagePopup("Confirm Checklist", "Checklist not created, please go back to page one to start creating checklist.", "error");
              }
              else{
                this.showMessagePopup("Upload Digital Signature", "Unable to upload digital signature. Please try again or contract the support.", "error");
              }
              
            });
        });

    },
    showMessagePopup(title, msg, type, then) {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true,
      }).then(() => (then && then()) || false);
    },
    confirmSignature(){
      this.saveSignature(this.updateCheckList);
    },
    updateCheckList() {
      this.loading = true;
      // let checklist = {
      //   type: 4,
      //   checklist: {
      //     id:
      //       this.editChecklistId == null
      //         ? this.getChecklistId()
      //         : this.editChecklistId,
      //     confirmation: this.confirmation
      //   }
      // };
      this.existingChecklist.id = this.editChecklistId == null ? this.getChecklistId() : this.editChecklistId;
      this.existingChecklist.confirmation = this.confirmation;

      let checklist = {
        type: 4,
        checklist: this.existingChecklist
      };
      checklist.checklist.customerDetail = JSON.parse(checklist.checklist.customerDetail);
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then((res) => {
          if (res) {
            this.completeInd = true;
            this.$message.success(
              "WIOA checklist has been completed successfully!"
            );
            localStorage.removeItem("editChecklist");
            this.$router.push({ name: "EligibilityDashboard" });
          }
        })
        .catch((res) => {
          this.showErrorWindow = true;
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetSignature() {
      const { isEmpty, data } = this.$refs.checklistSignature.saveSignature();
      console.log(data);
      this.$refs.checklistSignature.clearSignature();
    },
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
<style lang="scss" scoped>
.reviewer-feedback-signature-header-clear{
  cursor: pointer; 
}

.el-dialog__body{
  padding-top: 0px !important;
}

.wide {
  width: 250px;
  margin: auto;
  margin-top: 40px;
  color: white;
}
</style>>